(function() {

	document.addEventListener('DOMContentLoaded', function() {

		const acfFieldName = 'field_6033d8dbc992c';
		const acfInputName = 'acf-field_602d261ecf411-row';

		const resultsTable = document.querySelector("#bkc-content-results");

		if(!resultsTable) {
			return;
		}

		const tableInputs = resultsTable.querySelectorAll(".bkc-match-results-input.bkc-input-editable");


		// Add input event listener on all editable inputs
		Array.prototype.forEach.call(tableInputs, function(input) {
			input.addEventListener("input", function(){
			  	bkc_digiest_input(event, input);
			  	console.log(input);
			  	let json = bkc_collect_results(input);
			  	console.log(json);

	  			bkc_update_acf_field(input, json);
			});

		});

		// Digest input and edit linked inputs
		function bkc_digiest_input(e, input) {
			let bindingName 	= input.dataset.bindInput;
			let teamNumber 		= input.dataset.team;
		  	let linkedInputs 	= resultsTable.querySelectorAll('.bkc-content-results-table .bkc-match-results-input[data-bind-input^="' + bindingName + '"]');
		  	let newValue 		= input.value;

		  	input.classList.add('bkc-input-changed');

		  	Array.prototype.forEach.call(linkedInputs, function(linkedInput) {
		  		linkedInput.value = newValue
		  		linkedInput.classList.add('bkc-input-changed');
		  	}); 
		}

		// Digest input and edit linked inputs
		function bkc_collect_results(input) {
			var teamNumber		= input.dataset.team;
			var teamRows 		= resultsTable.querySelectorAll('.bkc-content-results-table [data-team-row="'+teamNumber+'"]');
			var allResults		= [];

		  	Array.prototype.forEach.call(teamRows, function(teamRow) {

		  		var teamResults	= teamRow.querySelectorAll('.bkc-content-results-table [data-bind-input][data-team="'+teamNumber+'"]');

		  		allResults[teamNumber] = [];
		  		allResults[teamNumber][0] = []; 
		  		allResults[teamNumber][1] = []; 
		  		allResults[teamNumber][2] = []; 

		  		Array.prototype.forEach.call(teamResults, function(matchResult) {

		  			var series 		= matchResult.dataset.series;
		  			var matchNumber = matchResult.dataset.match;
		  			var result 		= matchResult.value ? matchResult.value : 0; 

		  			allResults[teamNumber][series][matchNumber] = result;
		  		});
		  	});

		  	let jsonData = JSON.stringify( Object.assign({}, allResults) );

		  	return jsonData;
		}

		function bkc_update_acf_field(input, data) {
			let teamNumber 	= input.dataset.team;

			let fieldName 	= acfInputName+'-'+teamNumber+'-'+acfFieldName;

			let field 		= document.getElementById(fieldName);
			field.value 	= data;
		}

	});

})();